import React from 'react';
import { MarkerF } from '@react-google-maps/api';

export interface PropertyLabelMarkerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  property: Record<string, any>;
  onClick: () => void;
}

function LocalLifeLabelMarker({ property, onClick }: PropertyLabelMarkerProps) {
  return (
    <MarkerF
      key={property?.propertyId}
      icon={{
        url: '/mapImages/videoTour.svg',
        scaledSize: new window.google.maps.Size(0, 0)
      }}
      label={{
        text: property?.name,
        className: 'local-life-property-marker-label'
      }}
      onClick={onClick}
      position={
        {
          lat: property?.location?.lat || 0,
          lng: property?.location?.lon || 0
        } as google.maps.LatLng
      }
    />
  );
}

export default LocalLifeLabelMarker;
